import React, { useContext } from "react";
import classes from "./BlogsCard.module.css";
import { formatDate } from "../../gallery-list/gallery-card/GalleryCard";
import { extractTextFromHTML } from "../../../../components/extract-from-html/ExtractFromHtml";
import { useLocation, useNavigate } from "react-router-dom";
import { useLocale } from "antd/es/locale";
import { NavigationContext } from "../../../../App";

const BlogsCard = ({ data }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setIsBackNavigation } = useContext(NavigationContext);
  const sessionStore = location?.pathname?.includes("/branch")
    ? "branches"
    : location?.pathname?.includes("online-consultation")
    ? "online-consultation"
    : "home";

  return (
    <div className={`${classes.outer} bg-primary-100`}>
      <img
        src={data?.images?.find((item) => item?.mainImage == "yes")?.url}
        alt={data?.images?.find((item) => item?.mainImage == "yes")?.imageTag}
      />
      <h4>{formatDate(data?.createdAt)}</h4>
      <h1>{data?.title}</h1>
      {/* <div className={classes.underLine}></div> */}
      <p>{extractTextFromHTML(data?.homeDescription)}</p>
      <button
        onClick={() => {
          const yPos = window.scrollY;
              sessionStorage.setItem("scrollTargetY", yPos.toString());
              setIsBackNavigation(true)
              sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
          navigate(`/blogs/${data?.slug}`)}}
        className="primaryHover"
      >
        Know More
      </button>
    </div>
  );
};

export default BlogsCard;
